import "./assistant.027f871b.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e6c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e6c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("86Wyx", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.41', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HONOR = 'Honor', HUAWEI = 'Huawei', LENOVO = 'Lenovo', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', NVIDIA = 'Nvidia', ONEPLUS = 'OnePlus', OPERA = 'Opera', OPPO = 'OPPO', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
                /\b(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        'OnePlus': [
                            '304',
                            '403',
                            '203'
                        ],
                        '*': OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    'Nokia'
                ]
            ],
            [
                // Google
                /(pixel (c|tablet))\b/i // Google Pixel C/Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Archos
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i // Infinix XPad
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i // Nvidia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i // Nvidia Shield TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                // SmartTV from Unidentified Vendors
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i // Nvidia Portable
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i // Asus ZenWatch / LG Watch / Pixel Watch
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i // Oppo Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i // OnePlus Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i // Motorola 360
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i // Sony SmartWatch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i // LG G Watch R
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i // Apple HomePod
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i // LibWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    'LibWeb'
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i // Ubuntu Touch
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Touch'
                ],
                VERSION
            ],
            [
                // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});


var $cIxq8 = parcelRequire("cIxq8");

var $1f5FT = parcelRequire("1f5FT");

var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");
parcelRequire("7rUQ4");

var $cEKee = parcelRequire("cEKee");

var $cEKee = parcelRequire("cEKee");
function $63eba5f98fc64fbd$export$46c1c92549715335() {
    let poweredByHtml = (0, $cEKee.isHiddenPoweredBy) ? '' : `
            <span>Powered by <b style="margin-left: 3px;"><u class="powered_by"></u></b></span>
        `;
    return `
    <div class="loading__wrapper">
        <div class="loader">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                style="margin: auto; background: none; display: block; shape-rendering: auto;" width="200px"
                height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <rect x="19.5" y="16" width="11" height="68" fill="${0, $cEKee.primaryColor}">
                    <animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline"
                        keyTimes="0;0.5;1" values="-4.400000000000006;16;16"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s"></animate>
                    <animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline"
                        keyTimes="0;0.5;1" values="108.80000000000001;68;68"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s"></animate>
                </rect>
                <rect x="44.5" y="16" width="11" height="68" fill="${0, $cEKee.primaryColor}">
                    <animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline"
                        keyTimes="0;0.5;1" values="0.6999999999999957;16;16"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s"></animate>
                    <animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline"
                        keyTimes="0;0.5;1" values="98.60000000000001;68;68" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                        begin="-0.1s"></animate>
                </rect>
                <rect x="69.5" y="16" width="11" height="68" fill="${0, $cEKee.primaryColor}">
                    <animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline"
                        keyTimes="0;0.5;1" values="0.6999999999999957;16;16"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1"></animate>
                    <animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline"
                        keyTimes="0;0.5;1" values="98.60000000000001;68;68"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1"></animate>
                </rect>
            </svg>
        </div>
        <div class="widget-footer light-bg">
            <span class="subFooter--1"></span>
            <span class="subFooter--2"></span>
            <span class="subFooter--3"></span>
            <span class="subFooter--4">
                ${poweredByHtml}
            </span>
            <span class="subFooter--5"></span>
        </div> 
    </div>
    `;
}



var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $8ENHq = parcelRequire("8ENHq");
function $bfd9910d6768a5ae$export$8320b44461f7a641() {
    const assistantIframe = document.querySelector('.assistant__container .assistant__content--iframe');
    /* Select instant quote */ if (document.querySelector(`*[data-id="assistant"][data-click="instant-quote-now"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="instant-quote-now"]`).forEach(function(element) {
        element.onclick = (e)=>{
            $bfd9910d6768a5ae$var$checkAssistantWidget();
            $bfd9910d6768a5ae$var$sendMessageWhenReady(assistantIframe, '.loading__wrapper', 'navigate' + (0, $cIxq8.EVENT_MESSAGE).INSTANT_QUOTE, '*', 100);
            e.preventDefault();
        };
    });
    /* Select Request consult */ if (document.querySelector(`*[data-id="assistant"][data-click="schedule-consultation"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="schedule-consultation"]`).forEach(function(element) {
        element.onclick = (e)=>{
            // Ignore synthetic clicks (e.g. from client scripts that dispatch to #popuphelp)
            // to avoid contributing to "Maximum call stack size exceeded" when both
            // our handler and the client's handler run and the client dispatches a click.
            if (!e.isTrusted) return;
            $bfd9910d6768a5ae$var$sendMessageWhenReady(assistantIframe, '.loading__wrapper', 'navigate' + (0, $cIxq8.EVENT_MESSAGE).REQUEST_CONSULT, '*');
            setTimeout(()=>{
                $bfd9910d6768a5ae$var$checkAssistantWidget();
            }, 100);
            e.preventDefault();
        };
    });
    /* Select FAQs */ if (document.querySelector(`[data-id="assistant"][data-click="faqs"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="faqs"]`).forEach(function(element) {
        element.onclick = (e)=>{
            $bfd9910d6768a5ae$var$checkAssistantWidget();
            $bfd9910d6768a5ae$var$sendMessageWhenReady(assistantIframe, '.loading__wrapper', 'navigate' + (0, $cIxq8.EVENT_MESSAGE).ASK_QUESTION, '*', 100);
            e.preventDefault();
        };
    });
    /* Select Text Us */ if (document.querySelector(`[data-id="assistant"][data-click="text-us"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="text-us"]`).forEach(function(element) {
        element.onclick = (e)=>{
            $bfd9910d6768a5ae$var$checkAssistantWidget();
            $bfd9910d6768a5ae$var$sendMessageWhenReady(assistantIframe, '.loading__wrapper', 'navigate' + (0, $cIxq8.EVENT_MESSAGE).TEXT_US, '*', 100);
            e.preventDefault();
        };
    });
    /* Select Procedure Eligibility */ if (document.querySelector(`*[data-id="assistant"][data-click="procedure-eligibility"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="procedure-eligibility"]`).forEach(function(element) {
        element.onclick = ()=>{
            $bfd9910d6768a5ae$var$checkAssistantWidget();
            assistantIframe.contentWindow.postMessage('navigate' + (0, $cIxq8.EVENT_MESSAGE).PROCEDURE_ELIGIBILITY, '*');
        };
    });
    /* Select see all services */ if (document.querySelector(`*[data-id="assistant"][data-click="see-all-services"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="see-all-services"]`).forEach(function(element) {
        element.onclick = ()=>{
            $bfd9910d6768a5ae$var$checkAssistantWidget();
            assistantIframe.contentWindow.postMessage('navigate' + (0, $cIxq8.EVENT_MESSAGE).SEE_ALL_SERVICES, '*');
        };
    });
    /* Select Non-surgical services */ if (document.querySelector(`*[data-id="assistant"][data-click="book-non-surgical-appointment"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="book-non-surgical-appointment"]`).forEach(function(element) {
        element.onclick = ()=>{
            $bfd9910d6768a5ae$var$checkAssistantWidget();
            assistantIframe.contentWindow.postMessage('navigate' + (0, $cIxq8.EVENT_MESSAGE).NON_SURGICAL_SERVICES, '*');
        };
    });
    /* Select Call */ if (document.querySelector(`[data-id="assistant"][data-click="call"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="call"]`).forEach(function(element) {
        element.onclick = ()=>{
            window.location.href = `tel:${0, $cEKee.phoneToCall}`;
        };
    });
    /* Open widget */ if (document.querySelector(`*[data-id="assistant"][data-click="open"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="open"]`).forEach(function(element) {
        element.onclick = ()=>{
            let widgetToggleBtnDom = document.querySelector('.assistant__container .assistant__button');
            if (widgetToggleBtnDom) {
                widgetToggleBtnDom.click();
                $bfd9910d6768a5ae$export$4a1e00f59ebd9cc5('remove');
            }
        };
    });
    /* Select Book Appointment */ if (document.querySelector(`*[data-id="assistant"][data-click="book-appointment"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="book-appointment"]`).forEach(function(element) {
        element.onclick = (e)=>{
            $bfd9910d6768a5ae$var$checkAssistantWidget();
            const assistantIframeTemp = document.querySelector('.assistant__container .assistant__content--iframe');
            if (assistantIframeTemp) $bfd9910d6768a5ae$var$sendMessageWhenReady(assistantIframeTemp, '.loading__wrapper', 'navigate' + (0, $cIxq8.EVENT_MESSAGE).BOOK_APPOINTMENT, '*', 100);
            e.preventDefault();
        };
    });
    /* Select Book Appointment */ if (document.querySelector(`*[data-id="assistant"][data-click="popup"]`)) document.querySelectorAll(`*[data-id="assistant"][data-click="popup"]`).forEach(function(element) {
        element.onclick = (e)=>{
            const selector = document.querySelector('script[data-id="assistant"]');
            const book_appointment = selector?.getAttribute('book_appointment');
            if (book_appointment) {
                const assistantIframeTemp = document.querySelector('.assistant__container .assistant__content--iframe');
                if (assistantIframeTemp) assistantIframeTemp.contentWindow.postMessage('navigate' + (0, $cIxq8.EVENT_MESSAGE).BOOK_APPOINTMENT, '*');
            }
            $bfd9910d6768a5ae$var$checkAssistantWidget();
            e.preventDefault();
        };
    });
}
function $bfd9910d6768a5ae$var$checkAssistantWidget() {
    if (!document.querySelector('.assistant__container').classList.contains('show')) (0, $8ENHq.toggleWidgetAssistant)();
}
function $bfd9910d6768a5ae$export$4a1e00f59ebd9cc5(type) {
    document.querySelector('.assistant__container .tooltip__text')?.classList?.[type]('hidden');
    document.querySelector('.assistant__container .assistant__button')?.classList?.[type]('hidden');
}
/* Send message to iframe when it's ready */ function $bfd9910d6768a5ae$var$sendMessageWhenReady(iframe, selector, message, origin = '*', checkInterval = 500) {
    let failCount = 0;
    const maxFails = 50;
    const element = document.querySelector(selector);
    const isReady = element ? element?.classList?.contains("hidden") : false;
    if (isReady) {
        iframe.contentWindow.postMessage(message, origin);
        return;
    }
    element?.classList?.add("temporary__display");
    const interval = setInterval(()=>{
        try {
            const isReady = element ? element?.classList?.contains("hidden") : false;
            if (isReady) {
                iframe.contentWindow.postMessage(message, origin);
                clearInterval(interval);
                setTimeout(()=>{
                    element?.classList?.remove("temporary__display");
                }, 0);
            }
        } catch (error) {
            failCount++;
            if (failCount >= maxFails) {
                clearInterval(interval);
                setTimeout(()=>{
                    element?.classList?.remove("temporary__display");
                }, 0);
            }
            console.warn('Error accessing iframe content:', error);
        }
    }, checkInterval);
}



var $hvLQT = parcelRequire("hvLQT");
function $77ab26eed20b2536$var$formatSource(source) {
    let result = source.includes('http://') ? source.replace('http://', '') : source.includes('https://') ? source.replace('https://', '') : source;
    return result.replace(/[^0-9a-zA-Z.]/g, '');
}
const $77ab26eed20b2536$var$urlParams = new URLSearchParams(window.location.search);
let $77ab26eed20b2536$var$landingPageParam = '';
if ($77ab26eed20b2536$var$urlParams.get((0, $cIxq8.ESTIMATE_ID_PARAM)) && !$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.EVENT_ID_PARAM)) && !$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.UPLOAD_ID_PARAM))) $77ab26eed20b2536$var$landingPageParam = `&${0, $cIxq8.ESTIMATE_ID_PARAM}=${$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.ESTIMATE_ID_PARAM))}`;
else if (!$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.ESTIMATE_ID_PARAM)) && $77ab26eed20b2536$var$urlParams.get((0, $cIxq8.EVENT_ID_PARAM)) && !$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.UPLOAD_ID_PARAM))) $77ab26eed20b2536$var$landingPageParam = `&${0, $cIxq8.EVENT_ID_PARAM}=${$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.EVENT_ID_PARAM))}`;
else if (!$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.ESTIMATE_ID_PARAM)) && !$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.EVENT_ID_PARAM)) && $77ab26eed20b2536$var$urlParams.get((0, $cIxq8.UPLOAD_ID_PARAM))) $77ab26eed20b2536$var$landingPageParam = `&${0, $cIxq8.UPLOAD_ID_PARAM}=${$77ab26eed20b2536$var$urlParams.get((0, $cIxq8.UPLOAD_ID_PARAM))}`;
const $77ab26eed20b2536$var$selector = document.querySelector('script[data-id="assistant"]');
const $77ab26eed20b2536$var$book_appointment = $77ab26eed20b2536$var$selector.getAttribute('book_appointment');
const $77ab26eed20b2536$var$appointmentChannel = (0, $er9E0.params)('appointment_channel_id') ? (0, $er9E0.params)('appointment_channel_id') : $77ab26eed20b2536$var$selector.getAttribute('appointment_channel');
if ($77ab26eed20b2536$var$urlParams.get((0, $cIxq8.BOOK_APPOINTMENT_PARAM)) || $77ab26eed20b2536$var$book_appointment) $77ab26eed20b2536$var$landingPageParam += `&${0, $cIxq8.BOOK_APPOINTMENT_PARAM}=true`;
const $77ab26eed20b2536$var$sourceParam = (0, $er9E0.params)('source') && (0, $er9E0.params)('source').length > 0 && (0, $er9E0.params)('source') !== 'null' ? `&source=${$77ab26eed20b2536$var$formatSource((0, $er9E0.params)('source'))}` : `&source=${document.referrer}`;
const $77ab26eed20b2536$var$widgetModal = $77ab26eed20b2536$var$selector.getAttribute('data-popup');
(0, $cEKee.setIsModalPopup)(!!$77ab26eed20b2536$var$widgetModal);
let $77ab26eed20b2536$var$isModalPopup = "";
if ($77ab26eed20b2536$var$widgetModal) {
    (0, $bfd9910d6768a5ae$export$4a1e00f59ebd9cc5)('add');
    $77ab26eed20b2536$var$isModalPopup = '&modal-popup=true';
}
const $77ab26eed20b2536$var$has_source = `&has_source=${(0, $er9E0.params)('source') && (0, $er9E0.params)('source').length > 0 && (0, $er9E0.params)('source') !== 'null' ? 1 : 0}`;
const $77ab26eed20b2536$var$mobileParam = (0, $cIxq8.MOBILE_SCREEN) || !!$77ab26eed20b2536$var$widgetModal ? '&mobile=true' : '';
const $77ab26eed20b2536$var$desktopParam = ((0, $er9E0.params)("staff_id") && (0, $er9E0.params)("procedure_id") && (0, $er9E0.params)((0, $cIxq8.FULL_PAGE)) || (0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID))) && !(0, $cIxq8.MOBILE_SCREEN) ? "&desktop=true" : "";
const $77ab26eed20b2536$var$domainParam = `&domain=${window.location.hostname}`;
const $77ab26eed20b2536$var$pathParam = `&path=${encodeURIComponent(window.location.pathname + window.location.search)}`;
const $77ab26eed20b2536$var$gclidParam = (0, $er9E0.params)('gclid') ? `&gclid=${(0, $er9E0.params)('gclid')}` : '';
const $77ab26eed20b2536$var$fbclidParam = (0, $er9E0.params)('fbclid') ? `&fbclid=${(0, $er9E0.params)('fbclid')}` : '';
const $77ab26eed20b2536$var$utmMediumParam = (0, $er9E0.params)('utm_medium') ? `&utm_medium=${(0, $er9E0.params)('utm_medium')}` : '';
const $77ab26eed20b2536$var$utmSourceParam = (0, $er9E0.params)('utm_source') ? `&utm_source=${(0, $er9E0.params)('utm_source')}` : '';
const $77ab26eed20b2536$var$utmCampaignParam = (0, $er9E0.params)('utm_campaign') ? `&utm_campaign=${(0, $er9E0.params)('utm_campaign')}` : '';
const $77ab26eed20b2536$var$utmNetworkParam = (0, $er9E0.params)('utm_network') ? `&utm_network=${(0, $er9E0.params)('utm_network')}` : '';
const $77ab26eed20b2536$var$ignoreIframe = (0, $er9E0.params)((0, $cIxq8.IGNORE_IFRAME)) ? `&${0, $cIxq8.IGNORE_IFRAME}=${(0, $er9E0.params)((0, $cIxq8.IGNORE_IFRAME))}` : '';
const $77ab26eed20b2536$var$staffIdParam = (0, $er9E0.params)('staff_id') ? `&staff_id=${(0, $er9E0.params)('staff_id')}` : '';
const $77ab26eed20b2536$var$procedureIdParam = (0, $er9E0.params)('procedure_id') ? `&procedure_id=${(0, $er9E0.params)('procedure_id')}` : '';
function $77ab26eed20b2536$export$a5a157f0635fdb8b() {
    const tooltipData = $77ab26eed20b2536$var$urlParams.get((0, $cIxq8.BOOK_APPOINTMENT_PARAM)) || $77ab26eed20b2536$var$book_appointment ? "Book Appointment" : (0, $cEKee.tooltip);
    const isHidden = (0, $cIxq8.MOBILE_SCREEN) ? (0, $cEKee.isHiddenOnMobile) : (0, $cEKee.isHiddenOnDesktop);
    const pictureData = (0, $cEKee.picture);
    if ($77ab26eed20b2536$var$urlParams.get((0, $cIxq8.NEW_LEAD_UPLOAD))) $77ab26eed20b2536$var$landingPageParam += `&${0, $cIxq8.UPLOAD_ID_PARAM}=${(0, $cEKee.leadInfo).text_id}`;
    if ($77ab26eed20b2536$var$staffIdParam) $77ab26eed20b2536$var$landingPageParam += $77ab26eed20b2536$var$staffIdParam;
    if ($77ab26eed20b2536$var$procedureIdParam) $77ab26eed20b2536$var$landingPageParam += $77ab26eed20b2536$var$procedureIdParam;
    if ((0, $er9E0.params)((0, $cIxq8.ESTIMATE))) $77ab26eed20b2536$var$landingPageParam += `&${0, $cIxq8.ESTIMATE}=true`;
    if ((0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID)) || $77ab26eed20b2536$var$appointmentChannel) $77ab26eed20b2536$var$landingPageParam += `&${0, $cIxq8.APPOINTMENT_CHANNEL_ID}=${(0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID)) || $77ab26eed20b2536$var$appointmentChannel}`;
    if (!(0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID)) && $77ab26eed20b2536$var$appointmentChannel) $77ab26eed20b2536$var$landingPageParam += `&appointment_channel_for_floater=true`;
    if ((0, $hvLQT.apiClient).inIframe()) $77ab26eed20b2536$var$landingPageParam += `&in_iframe=true`;
    return `
    <div class="assistant__container ${$77ab26eed20b2536$var$desktopParam ? 'desktop-ver' : ""} ${$77ab26eed20b2536$var$widgetModal && $77ab26eed20b2536$var$book_appointment ? 'modal' : ''}">
    <div class="tooltip__text verticalShake hidden  ${isHidden ? 'hidden-widget' : ''}">
        <span class="close-tooltip-btn">
            <svg xmlns="http://www.w3.org/2000/svg" class="tooltip-btn-icon sm" viewBox="0 0 512 512">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144M368 144L144 368" class="ionicon-fill-none"></path>
            </svg>
        </span>
        <div class="tooltip__content">
            ${tooltipData || "Book Appointment"}
        </div>
    </div>
    
    <div class="assistant__button hidden ${isHidden ? 'hidden-widget' : ''}">
        <span class="open-btn">
            ${pictureData ? `<img src="${"https://storage.googleapis.com/pp-logos/"}${pictureData}" width="60px" height="60px" />` : '<svg class="btn-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324" stroke="white" fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="40"/><circle cx="250" cy="400" r="20" fill="white"/></svg>'}
        </span>
        <span class="close-btn">
            <svg xmlns="http://www.w3.org/2000/svg" class="btn-icon md hydrated" viewBox="0 0 512 512"><path fill="white" d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"></path></svg>
        </span>
    </div>
    
    <div id="widgetContentContainer" class="widgetContent__container animated">
        <span class="subCLose__btn">
            ${$77ab26eed20b2536$var$widgetModal ? `<ion-icon name="close-outline"></ion-icon>` : `<svg width="24" height="24" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M112 184l144 144 144-144" stroke="white" fill="none" class="ionicon-fill-none"></path>
                </svg>`}
        </span>
        <div class="widget__body">
            <iframe data-hj-allow-iframe
            sandbox="allow-forms allow-popups-to-escape-sandbox allow-modals allow-popups allow-scripts allow-same-origin allow-top-navigation-by-user-activation allow-top-navigation"
            class="assistant__content--iframe"
            src="${0, $cEKee.appUrl}/assistant.html?form=${0, $cEKee.formId}&token=${0, $cEKee.access_token}&appUrl=${0, $cEKee.appUrl}&color=${(0, $cEKee.primaryColor).substring(1)}${$77ab26eed20b2536$var$mobileParam}${$77ab26eed20b2536$var$desktopParam}${$77ab26eed20b2536$var$sourceParam}${$77ab26eed20b2536$var$domainParam}${$77ab26eed20b2536$var$pathParam}${$77ab26eed20b2536$var$gclidParam}${$77ab26eed20b2536$var$fbclidParam}${$77ab26eed20b2536$var$utmMediumParam}${$77ab26eed20b2536$var$utmSourceParam}${$77ab26eed20b2536$var$utmCampaignParam}${$77ab26eed20b2536$var$utmNetworkParam}${$77ab26eed20b2536$var$ignoreIframe}${$77ab26eed20b2536$var$has_source}${$77ab26eed20b2536$var$landingPageParam}${$77ab26eed20b2536$var$isModalPopup}">
            </iframe>

            ${(0, $63eba5f98fc64fbd$export$46c1c92549715335)()}
        </div>
    </div>
  </div>
  <div class="overlay__popup" style=${$77ab26eed20b2536$var$widgetModal && !$77ab26eed20b2536$var$book_appointment && 'display:none'}></div>
  `;
}


function $95c3c7a951ad75c1$export$2a47f398eeff8b01() {
    const ionicLib = document.createElement('script');
    ionicLib.type = 'module';
    ionicLib.src = 'https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js';
    const ionic = document.createElement('script');
    ionic.noModule = true;
    ionic.src = 'https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js';
    document.head.append(ionicLib);
    document.head.append(ionic);
    // Check for existing elements and remove them to prevent duplication
    $95c3c7a951ad75c1$var$removeElements([
        '.assistant__container',
        '.overlay__popup'
    ]);
    document.body.insertAdjacentHTML('beforeend', `${(0, $77ab26eed20b2536$export$a5a157f0635fdb8b)()}`);
}
function $95c3c7a951ad75c1$var$removeElements(selectors) {
    selectors.forEach((selector)=>{
        const element = document.querySelector(selector);
        if (element) element.remove();
    });
}


const $c8feda4a11f32f2c$export$82022331d82a7ba2 = (primaryColor)=>`
.assistant__container *, :after, :before {
    box-sizing: border-box !important;
}
.assistant__container {
    z-index: 99999999999;
    position: fixed; 
    bottom: 20px; 
    right: 20px;
    font-weight: 300;
    font-family: Nunito,system-ui,BlinkMacSystemFont,-apple-system,sans-serif !important;
}
.assistant__container.show {
    height: 90%;
    max-height: 800px;
}
.assistant__container .hidden {
    display: none !important;
}
.assistant__container .assistant__button {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 11;
    background-color: ${primaryColor};
    border: 5px solid white;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.assistant__container .assistant__button .open-btn > img {
    position: absolute;
    border-radius: 50%;
    object-fit: cover;
    top: 0;
}
.assistant__container .assistant__button .open-btn > ion-icon {
    visibility: visible !important;
}
.assistant__container .assistant__button:hover {
    bottom: 3px;
}
.assistant__container .open-btn {
    display: inline;
    position: relative;
    width: 100%;
    height: 100%;
}
.assistant__container.show .open-btn {
    display: none;
}
.assistant__container .close-btn {
    display: none;
}
.assistant__container.show .close-btn {
    display: inline;
}
.assistant__container .btn-icon {
    height: 40px;
    width: 40px;
    color: white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.assistant__container .widgetContent__container {
    width: 380px;
    max-width: 380px;
    right: 0;
    bottom: 0;
    height: 100%;
    border-radius: 15px;
    background-color: transparent;
    z-index: 10;
    display: none;
}
.assistant__container.show .widgetContent__container {
    display: block;
}
.assistant__container.show .subCLose__btn {
    display: flex;
}
.assistant__container .widgetContent__container.hidden {
    max-height: 0px;
}
.assistant__container .widget__body {
    background-color: transparent;
    border-radius: 15px;
    box-shadow: rgb(0 0 0 / 16%) -20px -20px 40px 0px;
    height: 100%;
}
.assistant__container .assistant__content--iframe {
    height: 100%;
    width: 100%;
    border: none;
    border-radius: 15px;
}
.assistant__container .subCLose__btn {
    position: absolute;
    background: rgba(0,0,0,0.07);
    height: 38px;
    width: 38px;
    font-size: 21px;
    align-items: center;
    justify-content: space-around;
    border-radius: 8px;
    top: 14px;
    right: 12px;
    cursor: pointer;
    display: none;
    color: white;
    z-index: 10;
}
.assistant__container .subCLose__btn:hover {
    background: rgba(0,0,0,0.15);
    transform: scale(1.05);
}

.animated {
    -webkit-animation-duration: 0.4s;
    animation-duration: 0.4s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

@-webkit-keyframes fadeInUp {
    from {
        opacity: 0;
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
    }

    to {
        opacity: 1;
        -webkit-transform: translateY(0, 0, 0);
        transform: translateY(0, 0, 0);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
    }

    to {
        opacity: 1;
        -webkit-transform: translateY(0, 0, 0);
        transform: translateY(0, 0, 0);
    }
}

@-webkit-keyframes fadeOutDown {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
        -webkit-transform: translate3d(0, 100%, 0);
        transform: translate3d(0, 100%, 0);
    }
}

@keyframes fadeOutDown {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
        -webkit-transform: translate3d(0, 100%, 0);
        transform: translate3d(0, 100%, 0);
    }
}

@-webkit-keyframes verticalShake {
    from {
        -webkit-transform: translateY(5px);
        transform: translateY(5px);
    }

    to {
        opacity: 1;
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }
}

@keyframes verticalShake {
    from {
        -webkit-transform: translateY(5px);
        transform: translateY(5px);
    }

    to {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }
}

.fadeInUp {
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
}

.fadeOutDown {
    -webkit-animation-name: fadeOutDown;
    animation-name: fadeOutDown;
}

.verticalShake {
    animation: verticalShake 1.5s infinite;
    animation-direction: alternate-reverse;
    animation-timing-function: linear;
}
.overlay__popup {
    position: fixed;
    inset: 0;
    opacity: 0.699999988079071;
    background: #000;
    display: none;
}

.desktop-ver.assistant__container {
    width: 100%  !important;
    bottom: 0 !important; 
    right: 0 !important;
}
.desktop-ver.assistant__container.show {
    height: 100%;
    min-height: 100%;
    max-height: 100% !important;
    max-width: 100%  !important;
}
.desktop-ver.assistant__container .widgetContent__container {
    width: 100%;
    max-width: 100%;
}
.desktop-ver.assistant__container .tooltip__text {
    max-width: 65vw !important;
}
.desktop-ver .assistant__button {
    z-index: -1 !important;
    bottom: 20px !important;
    right: 20px !important;
}
.desktop-ver .assistant__button:hover {
    bottom: 23px;
}
.desktop-ver.assistant__container .tooltip__text {
    right: 110px !important;
    bottom: 25px !important;
}
.desktop-ver.assistant__container .assistant__content--iframe {
    height: 100%;
    width: 100%;
    border: none;
    border-radius: 0;
}
.desktop-ver.assistant__container .subCLose__btn {
    display: flex;
}
.desktop-ver.assistant__container .subFooter--2 {
    box-shadow: none;
}
.desktop-ver.assistant__container .subFooter--4 {
    width: 100%;
    border-radius: 0;
}

.assistant__container  .hidden-widget {
    visibility: hidden !important;
    opacity: 0 !important;
}
.assistant__container.show  .hidden-widget {
    visibility: visible !important;
    opacity: 1 !important;
}

.loading__wrapper.temporary__display {
    display: flex !important;
}
`;


const $7e4ff6f8f528d679$export$4e6f96734dfe12f4 = `
.assistant__container .tooltip__text {
    width: max-content;
    right: 100px;
    bottom: 5px;
    position: absolute;
    border-radius: 15px;
    padding: 1rem;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
    z-index: 1;
    font-family: Nunito,system-ui,BlinkMacSystemFont,-apple-system,sans-serif;
    font-size: 16px;
    background-color: white;
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #4a4a4a;
}
.assistant__container .tooltip__text .hidden {
    dispplay:hidden;
}
.assistant__container .tooltip__text .close-tooltip-btn {
    position: absolute;
    left: -8px;
    top: -6px;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    padding: 5px 5px;
    background-color: gray;
    cursor:pointer;
}

.assistant__container .tooltip__icon {
    line-height: 1;
}

.assistant__container .tooltip__content {
    font-size: 16px;
    font-weight: 500;
    max-width: 390px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.assistant__container .tooltip__text .close-tooltip-btn .tooltip-btn-icon {
  position: absolute;
  color:white;
  top:3px;
  right:3px;
  height:15px;
  width:15px;
}
.assistant__container .tooltip__text span {
    margin-right: 8px;
    font-size: 23px;
    position: relative;
}
.assistant__container .tooltip__text::after {
    content: "";
    position: absolute;
    top: 33%;
    left: 101%;
    margin-left: -5px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent transparent white;
}
.assistant__container.show .tooltip__text {
    display: none;
}
`;



var $cEKee = parcelRequire("cEKee");
const $6887858d6a479dd5$export$8f880b6e390052fa = `
@media only screen and (max-width: 600px){
    .assistant__container {
        width: 100%  !important;
        bottom: 0 !important; 
        right: 0 !important;
    }
    .assistant__container.show {
        height: 100%;
        min-height: 100%;
        max-height: 100% !important;
        max-width: 100%  !important;
    }
    .assistant__container .widgetContent__container {
        width: 100%;
        max-width: 100%;
    }
    .assistant__container .tooltip__text {
        max-width: 65vw !important;
    }
    .assistant__button {
        z-index: -1 !important;
        bottom: 20px !important;
        right: 20px !important;
    }
    .assistant__button:hover {
        bottom: 23px;
    }
    .assistant__container .tooltip__text {
        right: 110px !important;
        bottom: 25px !important;
    }
    .assistant__container .assistant__content--iframe {
        height: 100% !important;
        width: 100% !important;
        border: none;
        border-radius: 0;
    }
    .assistant__container .subCLose__btn {
        display: flex;
    }
    .assistant__container .subFooter--2 {
        box-shadow: none;
    }
    .assistant__container .subFooter--4 {
        width: 100%;
        border-radius: 0;
    }
    
    .assistant__container  .hidden-widget {
        visibility: hidden !important;
        opacity: 0 !important;
    }

    .assistant__container.show  .hidden-widget {
        visibility: visible !important;
        opacity: 1 !important;
    }
}`;


const $1860a32dcb89d9af$export$d0e85600c25cfb6 = `
.assistant__container .loading__wrapper{
    background-color: transparent;
    position: absolute;
    width: 100%;
    top: 0;
    box-shadow: none;
    opacity: 0.8;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 10;
    opacity: 1;
    right: 0;
    transition: right .5s;
    height: 100%;
    flex-direction: column;
}
.assistant__container .loading__wrapper .loader {
    height: 100%;
    display: flex;
    width: 100%;
    background: white;
    border-radius: 15px 15px 10px 0;
}
.assistant__container .loading__wrapper svg {
    width: 75px;
}`;


const $83e7fea319e703ec$export$c19244d3e10df333 = `
.assistant__container .widget-footer {
    min-height: 86px;
    position: relative;
    width: 100%;
    transition: right .5s;
    margin-top: auto;
}
.assistant__container .subFooter--1 {
    width: 100%;
    position: absolute;
    height: 17px;
    top: -17px;
    left: 0;
    background: white;
    border-radius: 0 0 20px 0;
    z-index: 1;
}
.assistant__container .subFooter--2 {
    background: white;
    border-radius: 0 0 50px 50px;
    bottom: 82px;
    height: 19px;
    position: absolute;
    right: 0;
    width: 26px;
    box-shadow: -7px 13px 20px 0px rgb(0 0 0 / 16%);
}
.assistant__container .subFooter--3 {
    width: 19px;
    height: 30px;
    position: absolute;
    background: white;
    bottom: 0px;
    right: 81px;
    border-radius: 0 50px 50px 0;
}
.assistant__container .subFooter--4 {
    align-content: flex-end;
    align-items: center;
    background-color: white;
    border-radius: 0 0 12px 15px;
    color: gray;
    display: flex;
    font-size: 14px;
    height: 100%;
    justify-content: center;
    padding: 1rem;
    width: calc(100% - 85px);
    box-shadow: 0px 32px 40px 6px rgb(0 0 0 / 16%);
}
.assistant__container .subFooter--4 span {
    cursor: pointer;
}
.assistant__container .subFooter--5 {
    width: 100px;
    height: 100px;
    border-radius: 50px;
    box-shadow: -19px -19px 0 -3px white;
    position: absolute;
    right: -15px;
    top: 0;
}
`;


const $b01a06678c0978e6$export$44330d9b67471f5d = ()=>`
.assistant__container *, :after, :before {
    box-sizing: border-box !important;
}
.assistant__container {
    z-index: 9999999;
    position: fixed; 
    width: 500px;
    height: 500px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}


.assistant__container.show {
    height: 90%;
    max-height: 600px;
}

.assistant__container.modal.show {
    height: 90%;
    max-height: 335px;
}

.assistant__container.modal.show .subCLose__btn {
    background: rgb(0 0 0 / 76%);
}

.assistant__container .widgetContent__container {
    width: 100%;
    max-width: 100%;
}

.assistant__container .subCLose__btn {
    display: flex;
}

.assistant__container .subFooter--2 {
    box-shadow: none;
}
.assistant__container .subFooter--4 {
    width: 100%;
    border-radius: 0;
}

.widgetContent__container {
    box-shadow: 10px 10px 40px 20px #00000029;
}

.assistant__container.show + .overlay__popup {
    display: flex;
}

.assistant__container.show + .overlay__popup.hide {
    display: none;
}
`;


function $9052d98c951bd683$export$31f077b88a3c784c() {
    let styles = ``;
    styles = styles.concat((0, $c8feda4a11f32f2c$export$82022331d82a7ba2)((0, $cEKee.primaryColor))).concat((0, $7e4ff6f8f528d679$export$4e6f96734dfe12f4)).concat((0, $1860a32dcb89d9af$export$d0e85600c25cfb6)).concat((0, $83e7fea319e703ec$export$c19244d3e10df333)).concat((0, $6887858d6a479dd5$export$8f880b6e390052fa)).concat((0, $cEKee.isModalPopup) ? (0, $b01a06678c0978e6$export$44330d9b67471f5d)() : []);
    const styleTag = document.createElement('style');
    styleTag.innerHTML = styles.replace(/^\s+|\n/gm, '');
    document.head.appendChild(styleTag);
}



var $8ENHq = parcelRequire("8ENHq");


var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");
function $f700423338ff395d$export$18d0fd55b1b3892d() {
    window.addEventListener('keydown', (e)=>{
        if (e.key === 'Tab') e.preventDefault();
    });
    window.addEventListener('message', $f700423338ff395d$var$listenMessageIframe);
    (0, $95c3c7a951ad75c1$export$2a47f398eeff8b01)();
    (0, $8ENHq.assistantListeners)();
    (0, $bfd9910d6768a5ae$export$8320b44461f7a641)();
    if ((0, $er9E0.params)((0, $cIxq8.UPLOAD_ID_PARAM)) || (0, $er9E0.params)((0, $cIxq8.NEW_LEAD_UPLOAD)) || (0, $er9E0.params)((0, $cIxq8.EVENT_ID_PARAM)) || (0, $er9E0.params)((0, $cIxq8.ESTIMATE_ID_PARAM)) || (0, $er9E0.params)((0, $cIxq8.IGNORE_IFRAME)) || (0, $er9E0.params)((0, $cIxq8.BOOK_APPOINTMENT_PARAM))) {
        let widgetToggleBtnDom = document.querySelector('.assistant__container .assistant__button');
        if (widgetToggleBtnDom) widgetToggleBtnDom.click();
    }
    (0, $9052d98c951bd683$export$31f077b88a3c784c)();
    const audio = document.getElementById('myAudio');
    if (audio) audio.onended = ()=>{
        localStorage.setItem('loadAudio', true);
    };
}
function $f700423338ff395d$var$listenMessageIframe(event) {
    if (event?.data?.type === (0, $cIxq8.HIDE_WIDGET)) {
        const checkWidgetData = event?.data?.hide_widget ? 'add' : 'remove';
        if (!(0, $cEKee.isModalPopup)) (0, $bfd9910d6768a5ae$export$4a1e00f59ebd9cc5)(checkWidgetData);
    }
    if (event?.data === (0, $cIxq8.OPEN_BOOK_APPOINTMENT_MODAL)) {
        let assistant = document?.querySelector('.assistant__container');
        if (assistant) assistant.classList.remove('modal');
    }
    if (event?.data === 'close_modal_popup') (0, $8ENHq.closeAssistant)();
}



var $cEKee = parcelRequire("cEKee");

var $hvLQT = parcelRequire("hvLQT");

var $er9E0 = parcelRequire("er9E0");
parcelRequire("86Wyx");

var $2q2gk = parcelRequire("2q2gk");
const $f3159c57aa909ef1$export$b5cca9c1620f9dd7 = `
* {
    box-sizing: border-box;
    font-family: "Poppins", sans-serif;
}
.wrapper-login {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    justify-content: center;
    position: fixed;
    inset: 0;
    overflow-y: auto;
    overflow: hidden;
}

.wrapper-login .errorText {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: rgb(220, 53, 69);
    width: 100%;
    display: block;
    text-align: center;
    margin-bottom: 12px;
}

.wrapper-login .container{
    width: 100%;
    height: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    background: rgb(245, 246, 250)
}

.wrapper-login .container-left {
    max-width: 680px;
    padding: 0px;

    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/png/background_login_portal.png);
    background-repeat: no-repeat;
    background-size: cover;
    justify-content: center;
    position: relative;
    display: flex;
}

.wrapper-login .container-left .wrap-left {
    display: flex;
    flex-direction: column;
}

.wrapper-login .container-right {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    justify-content: center;
    padding: 20px;
}

.container-left .logo-project {
    margin: 70px 0px 50px;
}

.container-left .logo-project img {
    width: 160px;
    max-width: 100%;
}

.container-left .info-project {
    padding: 24px;
    width: 520px;
    max-width: 520px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    border-radius: 16px;
    background: rgb(255, 255, 255);
}

.container-left .info-project .info-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.container-left .info-project .info-item .icon {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 10px;
    border-radius: 100px;
    background: rgba(242, 244, 246, 0.96);
    margin-bottom: 0px;
}

.container-left .info-project .info-item .text {
    color: rgb(14, 64, 95);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.container-left a {
    transition: all 0.4s ease 0s;
    color: rgb(14, 64, 95);
    text-decoration: none;
}

.wrapper-login ion-icon {
    font-size: 24px;
}

.container-right .wrap-right {
    osition: relative;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    font-style: normal;
    width: 100%;
    padding: 12px;
    border: 1px solid rgb(240, 245, 245);
    box-shadow: rgba(16, 24, 24, 0.03) 0px 0px 4px 1px;
    border-radius: 14px;
    max-width: 480px;
    padding: 40px;
}

.wrap-right .logo-project {
    margin: 0px auto 50px;
}

.wrap-right .logo-project img {
    width: 160px;
    max-width: 100%;
}

.wrap-right .title {
    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
    padding: 20px;
    text-align: center;
    letter-spacing: -0.002em;
    color: rgb(6, 30, 45);
}

.wrap-right .description {
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    color: rgb(131, 146, 165)
}
.fullName-screen__wrapper {
    height: calc(100% - 137px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f4f4f4;
}

.wrapper-login .phone__wrappers,
.wrapper-login .validateDigits__wrappers {
    background: none;
    padding: 0;
}

.wrapper-login .phone__wrappers .card,
.wrapper-login .validateDigits__wrappers .card{
    padding: 0;
}

.wrapper-login .phone__wrappers .phone__actions,
.wrapper-login .validateDigits__actions{
    padding: 0;
    width: 100%;
}

.wrapper-login .phone__wrappers .phoneContinue__btn,
.wrapper-login .validateDigitsContinue__btn {
    margin-top: 22px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 10px;
    gap: 10px;
    background: var(--primary-color);
    border-radius: 4px;
    width: 100%;
}

.wrapper-login .phone__wrappers .phoneContinue__btn:hover,
.wrapper-login .validateDigitsContinue__btn:hover {
    border: 1px solid var(--primary-color);
    color: white;
    opacity: 0.7;
}

.wrapper-login .phone__wrappers .phoneContinue__btn .loading__wrapper,
.wrapper-login .validateDigitsContinue__btn .loading__wrapper {
    border-radius: 4px;
}

.hidden {
    display: none!important;
}
`;



var $cEKee = parcelRequire("cEKee");
function $9b211f1727672a7a$export$2edf8f7d74ebd6c8(projectInfo) {
    document.body.style.setProperty('--primary-color', (0, $cEKee.primaryColor));
    (0, $cEKee.setProjectId)(projectInfo?.project_id);
    return `
        <div class="wrapper-login">
        <!-- Load error -->
        <div class="toast__container error animate__animated">
            <span class="close-error">
                <i class="ri-close-line"></i>
            </span>
            <span class="error-msg"></span>
        </div>
            <div class="container">
                <div class="container-left">
                    <div class="wrap-left">
                        <div class="logo-project">
                            <img src="${projectInfo?.business_photo || ""}" alt="logo"/>
                        </div>
                        <div class="info-project">
                        ${projectInfo?.location?.length > 0 && projectInfo?.location[0]?.full_address ? `
                                <div class="info-item">
                                    <span class="icon">
                                        <ion-icon name="location-outline"></ion-icon>
                                    </span>
                                    <span class="text">
                                        ${projectInfo?.location[0]?.full_address || ""}
                                    </span>
                                </div>
                            ` : ""}
                        ${projectInfo?.business_phone ? `
                            <div class="info-item">
                                <span class="icon">
                                <ion-icon name="call-outline"></ion-icon>
                                </span>
                                <span class="text">
                                <a
                                    href="tel:${projectInfo?.business_phone || ""}"
                                >
                                    ${projectInfo?.business_phone || ""}
                                </a>
                                </span>
                            </div>
                            ` : ""}
                        ${projectInfo?.business_email ? `
                            <div class="info-item">
                                <span class="icon">
                                <ion-icon name="mail-outline"></ion-icon>
                                </span>
                                <span class="text">
                                    <a
                                        href="mailto:${projectInfo?.business_email || ""}"
                                    >
                                        ${projectInfo?.business_email || ""}
                                    </a>
                                </span>
                            </div>
                            ` : ""}
                        ${projectInfo?.website ? `
                            <div class="info-item">
                                <span class="icon">
                                <ion-icon name="globe-outline"></ion-icon>
                                </span>
                                <span class="text">
                                <a
                                    href="${projectInfo?.website || ""}"
                                    target="_blank"
                                >
                                ${projectInfo?.website || ""}
                                </a>
                                </span>
                            </div>
                            ` : ""}
                        </div>
                    </div>
                </div>
                <div class="container-right">
                    <div class="wrap-right">
                    </div>
                </div>
            </div>
        </div>
  `;
}
function $9b211f1727672a7a$export$40005d3795cfa755() {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = (0, $f3159c57aa909ef1$export$b5cca9c1620f9dd7).replace(/^\s+|\n/gm, '');
    document.head.appendChild(styleTag);
}
function $9b211f1727672a7a$export$bd41ba04006fde31() {
    const ionicLib = document.createElement('script');
    ionicLib.type = 'module';
    ionicLib.src = 'https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js';
    document.head.append(ionicLib);
}



var $k3ko8 = parcelRequire("k3ko8");
var $1Yh2H = parcelRequire("1Yh2H");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $fQMeL = parcelRequire("fQMeL");

var $ifWoM = parcelRequire("ifWoM");

var $29QSo = parcelRequire("29QSo");

var $eq8l3 = parcelRequire("eq8l3");

var $577MR = parcelRequire("577MR");

var $jmDLz = parcelRequire("jmDLz");

function $bc16125a2dafc66b$export$f74bf3aa4976c520() {
    let tempUIStr = `
        <div class="logo-project">
            <img src="${(0, $cEKee.form)?.project?.business_photo || ""}" alt="logo"/>
        </div>
        <div class="title">
            Appointment Booking Login
        </div>
        <p class="description">
            Enter your phone number to book an appointment
        </p>
        <div class="errorText">
        </div>
        <div class="phone__container">
            <div class="phone__wrappers">
                    <div class="card">
                    <div class="phone--element">
                        <span class="phone__valid hidden">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span class="phone__invalid hidden">
                            <ion-icon name="close-outline"></ion-icon>
                        </span>
                        <div class="phone__wrapper--input">
                            <span class="phone__countryCode phone" id="phone__countryCode">
                                <div class="phone__selected-code phone">
                                    <img class="flag-icon selected-flag">
                                    <span class="selected-country-code"></span>
                                </div>
                                <div class="phone__countryCode--dropdown phone hidden">
                                    <ul class="phone__countryCode--select"></ul>
                                </div>
                            </span>
                            <input tabindex="-1" id="phone" class="phone--input" type="tel" autocomplete="tel"
                                placeholder="Enter your phone number" inputmode="tel">
                        </div>
                    </div>
                </div>
                <div class="phone__actions">
                    <div class="phoneContinue__btn disabled">
                        <span>Continue</span>
                        <span class="loader__icon">
                            <ion-icon name="arrow-forward-outline"></ion-icon>
                        </span>
                        <div class="loading__wrapper hidden">
                            <div class="loader">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                   
  `;
    let tempDom = document.querySelector('.wrapper-login .wrap-right');
    if (tempDom) {
        tempDom.innerHTML = tempUIStr;
        (0, $fQMeL.loadPhoneComponent)();
        $bc16125a2dafc66b$var$countryCodeListeners();
        $bc16125a2dafc66b$var$phoneListeners();
        const phoneInput = document.getElementById('phone');
        if (phoneInput) phoneInput.focus();
    }
}
function $bc16125a2dafc66b$var$renderValidate() {
    let tempUIStr = `
    <div class="validateDigits__container">
        <div class="validateDigits__wrappers">
            <div class="card">
                <div class="validateDigits--title-wrapper">
                    <div class="validateDigits--title-icon">
                        <div class="icon__background" style="background: ${(0, $cEKee.primaryColor)}0f;">
                            <ion-icon name="lock-closed-outline"></ion-icon>
                        </div>
                    </div>
                    <div class="validateDigits--title">
                        Enter 4 digit code sent to phone
                    </div>
                    <div class="errorText">
                    </div>
                    <div class="validateDigits--sub-title">
                        Sent to <strong></strong>
                    </div>
                    <div class="validateDigits--resend-otp">
                        <button class="button--no-style">
                        <ion-icon name="refresh-outline"></ion-icon>
                            <u>Resend</u>
                        </button>
                        <div class="validateDigits__resend-timer"></div>
                    </div>
                </div>
                <div class="validateDigits--element">
                    <div class="validateDigits__wrapper--input" tabindex="-1">
                        <input id="validateDigits0" class="validateDigits__wrapper--input-field" maxlength="4"
                            type="text" autocomplete="one-time-code" inputmode="numeric">
                        <input id="validateDigits1" class="validateDigits__wrapper--input-field" maxlength="1"
                            type="text" autocomplete="off" inputmode="numeric">
                        <input id="validateDigits2" class="validateDigits__wrapper--input-field" maxlength="1"
                            type="text" autocomplete="off" inputmode="numeric">
                        <input id="validateDigits3" class="validateDigits__wrapper--input-field" maxlength="1"
                            type="text" autocomplete="off" inputmode="numeric">
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="validateDigits__actions">
            <div class="validateDigitsContinue__btn disabled">
                Continue <span class="loader__icon"><ion-icon name="arrow-forward-outline"></ion-icon></span>
                <div class="loading__wrapper hidden">
                    <div class="loader">
                </div>
            </div>
        </div>
    </div>
    `;
    let tempDom = document.querySelector('.wrapper-login .wrap-right');
    tempDom.innerHTML = tempUIStr;
}
function $bc16125a2dafc66b$var$countryCodeListeners() {
    /* on click code number in dropdown */ const codes = document.querySelectorAll('.phone__countryCode--option');
    codes.forEach((i)=>{
        i.onclick = ()=>{
            (0, $cEKee.setSelectedCountry)(i.getAttribute('data-country'));
            (0, $cEKee.setSelectedCodeNumber)(i.getAttribute('data-country-code'));
            /* Change selected flag icon */ document.querySelectorAll('.selected-flag').forEach((j)=>{
                j.setAttribute('src', `${(0, $cEKee.appUrl)}/assets/images/svg/${i.getAttribute('data-country').toLowerCase()}.svg`);
            });
            /* Change selected country code */ document.querySelectorAll('.selected-country-code').forEach((j)=>{
                j.textContent = `+${i.getAttribute('data-country-code')}`;
            });
            (0, $eq8l3.toggleCountriesPhone)((0, $cIxq8.CLOSE));
        };
    });
    /* Click outside to close code number country dropdown PHONE screen*/ document.addEventListener('click', (0, $ifWoM.handleClickOutsidePagePhone));
}
function $bc16125a2dafc66b$var$phoneListeners() {
    (0, $29QSo.formatAndValidatePhone)();
    (0, $29QSo.toggleCountryCode)();
    document.getElementById('phone').addEventListener('focus', ()=>{
        let oldPhoneElement = document.querySelector(".phone--element.old-phone");
        if (oldPhoneElement) oldPhoneElement.style.backgroundColor = "#fff";
    });
    document.getElementById('phone').addEventListener('blur', ()=>{
        let oldPhoneElement = document.querySelector(".phone--element.old-phone");
        if (oldPhoneElement) oldPhoneElement.style.backgroundColor = "#ddd";
    });
    const phoneElement = document.querySelector('.phone__container .phone--element');
    document.getElementById('phone').onfocus = ()=>{
        phoneElement.style.borderColor = `${0, $cEKee.primaryColor}`;
    };
    document.getElementById('phone').onblur = ()=>{
        phoneElement.style.borderColor = `lightgrey`;
    };
    if (phoneElement) phoneElement.addEventListener('click', (e)=>{
        e.preventDefault();
        let error = false;
        let input = document.querySelector('.phone--input');
        if (!input.value || input.getAttribute('id') === 'phone' && !(0, $1Yh2H.isValidPhoneNumber)(input.value, (0, $cEKee.selectedCountry))) {
            input.classList.add('invalid');
            error = true;
        }
        if (error) return;
    });
    /* On click enter */ const screenPhone = document.querySelector('.wrapper-login');
    if (screenPhone) screenPhone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector('.phoneContinue__btn')?.classList.contains('disabled')) document.querySelector('.phoneContinue__btn')?.click();
    });
    /* on click Continue after input phone number*/ document.querySelector('.phoneContinue__btn').addEventListener('click', $bc16125a2dafc66b$var$handleClickPhoneContinue);
}
async function $bc16125a2dafc66b$var$handleClickPhoneContinue() {
    const errorElement = document?.querySelector(".wrapper-login .errorText");
    if (errorElement) errorElement.textContent = "";
    const loaderIcon = document.querySelector('.phoneContinue__btn .loader__icon');
    try {
        document.querySelector('.phoneContinue__btn')?.classList.add('disabled');
        document.querySelector('.phoneContinue__btn .loading__wrapper')?.classList.remove('hidden');
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        const normalizedPhone = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry))?.number;
        if (!normalizedPhone) throw new Error('Invalid phone number');
        if (!(0, $cEKee.form)?.is_phone_otp_enabled && (0, $cEKee.form)?.appointment_channel?.id) {
            const bookingTokenResponse = await (0, $jmDLz.createBookingToken)((0, $cEKee.form).appointment_channel.id, {
                phone: normalizedPhone,
                ...(0, $cEKee.visitorId) && {
                    visitor_id: (0, $cEKee.visitorId)
                }
            });
            const bookingLead = bookingTokenResponse?.data?.lead;
            if (bookingTokenResponse?.data?.access_token) (0, $cEKee.setAccessToken)(bookingTokenResponse.data.access_token);
            if (bookingLead) {
                (0, $cEKee.setLeadInfo)(bookingLead);
                if (bookingLead?.text_id) (0, $cEKee.setLeadTextId)(bookingLead.text_id);
            }
            (0, $a2b6b7e174bc02eb$export$43fe127fc3f91e2)((0, $cEKee.form));
            return;
        }
        if (0, $cEKee.isOTPTimeOut) await (0, $577MR.sendOTPCodeWithTimer)();
        else (0, $577MR.OTPTimer)();
        $bc16125a2dafc66b$var$renderValidate();
        $bc16125a2dafc66b$export$a61bd95ef2ddae90();
        document.getElementById('validateDigits0').focus();
        const phoneNumObj = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry));
        if (document.querySelector('.validateDigits--sub-title strong')) document.querySelector('.validateDigits--sub-title strong').innerHTML = phoneNumObj.number;
    } catch (error) {
        if (errorElement) errorElement.textContent = error.response?.data?.message;
    } finally{
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<ion-icon name="arrow-forward-outline"></ion-icon>`);
        }
        document.querySelector('.phoneContinue__btn .loading__wrapper')?.classList.add('hidden');
        document.querySelector('.phoneContinue__btn')?.classList.remove('disabled');
    }
}
function $bc16125a2dafc66b$export$a61bd95ef2ddae90() {
    const allowedKeys = [
        "Backspace",
        "Enter",
        "Tab",
        "ArrowLeft",
        "ArrowRight"
    ];
    /* On click enter */ const screenPhone = document.querySelector('.wrapper-login');
    if (screenPhone) screenPhone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector('.validateDigitsContinue__btn').classList.contains('disabled')) document.querySelector('.validateDigitsContinue__btn').click();
    });
    /* OTP input fields */ const validateDigitsDoms = [
        document.getElementById('validateDigits0'),
        document.getElementById('validateDigits1'),
        document.getElementById('validateDigits2'),
        document.getElementById('validateDigits3')
    ];
    const resendOTPBtnDom = document.querySelector('.validateDigits--resend-otp');
    /* on click Continue after input phone number*/ document.querySelector('.validateDigitsContinue__btn').addEventListener('click', async ()=>{
        const loaderIcon = document.querySelector('.validateDigitsContinue__btn .loader__icon');
        const errorElement = document?.querySelector(".wrapper-login .errorText");
        if (errorElement) errorElement.textContent = "";
        try {
            document.querySelector('.validateDigitsContinue__btn')?.classList.add('disabled');
            document.querySelector('.validateDigitsContinue__btn .loading__wrapper')?.classList.remove('hidden');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
            }
            let otpCode = '';
            validateDigitsDoms.forEach((element)=>{
                otpCode += element.value;
            });
            const tempLeadInfo = await (0, $jmDLz.loginPortal)((0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry)).number, otpCode, (0, $cEKee.projectId), (0, $cEKee.visitorId));
            (0, $cEKee.setAccessToken)(tempLeadInfo.data.access_token);
            const data = tempLeadInfo?.data?.lead;
            (0, $cEKee.setLeadInfo)(data);
            (0, $a2b6b7e174bc02eb$export$43fe127fc3f91e2)((0, $cEKee.form));
            validateDigitsDoms.forEach((element)=>{
                element.value = '';
            });
            validateDigitsDoms[0].focus();
        } catch (error) {
            validateDigitsDoms.forEach((element)=>{
                element.value = '';
            });
            validateDigitsDoms[0].focus();
            if ((error.response?.data?.message || error) && error.response?.status === 500) (0, $cEKee.setHasLead)(true);
            else if (errorElement) errorElement.textContent = error.response?.data?.message;
        } finally{
            document.querySelector('.validateDigitsContinue__btn')?.classList.remove('disabled--noneOpacity');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<ion-icon name="arrow-forward-outline"></ion-icon>`);
            }
            document.querySelector('.validateDigitsContinue__btn .loading__wrapper')?.classList.add('hidden');
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) document.querySelector('.validateDigitsContinue__btn')?.classList.remove('disabled');
        }
    });
    let pageOTPInputContinueBtn = document.querySelector('.validateDigitsContinue__btn');
    /* OTP input field validation - Only accept number */ validateDigitsDoms.forEach((element, index)=>{
        element.addEventListener('input', (event)=>{
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) pageOTPInputContinueBtn?.classList.remove('disabled');
            else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
            if (event.data?.length === 1 && validateDigitsDoms[index + 1]) {
                validateDigitsDoms[index + 1]?.focus();
                return;
            }
            if (element.id === 'validateDigits0' && element.value.length > 1) {
                for(let i = 0; i < validateDigitsDoms.length; i++)if (!validateDigitsDoms[i].value) {
                    validateDigitsDoms[i].value = event.target.value.split('')[event.target.value.length - 1];
                    element.value = event.target.value.split('')[0];
                    break;
                }
                if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) pageOTPInputContinueBtn?.classList.remove('disabled');
                else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
                return;
            }
        });
        element.addEventListener('keydown', (event)=>{
            if (event.key === 'Tab') event.stopPropagation();
            if ((isNaN(event.key) || event.key === " ") && !event.ctrlKey && !allowedKeys.includes(event.key)) {
                event.preventDefault();
                return;
            }
            if (event.key === "Backspace") {
                event.preventDefault();
                if (!validateDigitsDoms[index].value && validateDigitsDoms[index - 1]) validateDigitsDoms[index - 1].focus();
                validateDigitsDoms[index].value = "";
                if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
                return;
            } else if (element.id === 'validateDigits3' && event.key === "Tab") event.preventDefault();
        });
        element.addEventListener('beforeinput', (event)=>{
            if (event.data?.length > 1) {
                event.preventDefault();
                let eventDataArr = event.data.split('').filter((value)=>{
                    return !isNaN(value) && value !== " ";
                });
                if (eventDataArr.length > 4) eventDataArr = eventDataArr.slice(0, 4);
                eventDataArr.forEach((val, pos)=>{
                    validateDigitsDoms[pos].value = val;
                    if (validateDigitsDoms[pos + 1]) validateDigitsDoms[pos + 1].focus();
                });
            } else if (element.value && event.data) {
                event.preventDefault();
                element.value = event.data;
                if (validateDigitsDoms[index + 1]) validateDigitsDoms[index + 1].focus();
            }
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) pageOTPInputContinueBtn?.classList.remove('disabled');
            else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
        });
        element.addEventListener('paste', (event)=>{
            const paste = (event.clipboardData || window.clipboardData).getData('text').replaceAll(' ', '').split("");
            event.preventDefault();
            validateDigitsDoms.forEach((element, index)=>{
                if (paste[index] && !isNaN(paste[index])) element.value = paste[index];
            });
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) {
                pageOTPInputContinueBtn?.classList.remove('disabled');
                validateDigitsDoms[3].focus();
            } else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
        });
    });
    resendOTPBtnDom.addEventListener('click', async ()=>{
        (0, $577MR.sendOTPCodeWithTimer)();
    });
}


class $60c68fbfc7faa88c$var$PopupLibrary {
    constructor(popupCampaign){
        if (!popupCampaign || !popupCampaign.id) throw new Error('Invalid popup campaign data');
        this.id = popupCampaign.id;
        this.content = popupCampaign.content?.html || '';
        const defaultContentWidth = 500;
        const designContentWidth = popupCampaign.content?.design?.body?.values?.contentWidth;
        this.contentWidth = designContentWidth?.includes('px') ? parseInt(designContentWidth, 10) || defaultContentWidth : defaultContentWidth;
        const { timing: timing = {
            delay: 2,
            frequency: 'once'
        }, position: position = 'center', animation: animation = 'fade', targeting: targeting = {
            pages: [
                '*'
            ],
            devices: [
                'desktop',
                'mobile'
            ],
            audience: 'all',
            excludedUrls: []
        }, displayTrigger: displayTrigger = 'time', stopConditions: stopConditions = {
            afterClose: true,
            afterDisplayCount: 0,
            enableDisplayLimit: false,
            enableStopConditions: true
        } } = popupCampaign.configuration || {};
        this.timing = timing;
        this.position = position;
        this.animation = animation;
        this.targeting = targeting;
        this.displayTrigger = displayTrigger;
        this.stopConditions = stopConditions;
        this.updatedAt = popupCampaign.updated_at || Date.now().toString();
        // DOM elements
        this.popupWrapper = null;
        this.shadowRoot = null;
        this.popupContainer = null;
        this.overlay = null;
        this.closeBtn = null;
        this.storageKeyBase = `popup_${this.id}`;
        this.popupKey = `${this.storageKeyBase}_${this.updatedAt}_shown`;
        this.displayCountKey = `${this.storageKeyBase}_${this.updatedAt}_count`;
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        this.deviceType = this.isMobile ? 'mobile' : 'desktop';
        // Event handlers (stored for cleanup)
        this.escapeKeyHandler = this.handleEscapeKey.bind(this);
        this.clearOldStorageKeys();
    }
    clearOldStorageKeys() {
        try {
            const storages = [
                localStorage,
                sessionStorage
            ];
            storages.forEach((storage)=>{
                const keysToRemove = [];
                for(let i = 0; i < storage.length; i++){
                    const key = storage.key(i);
                    if (!key) continue;
                    if (key.startsWith('popup_') && (key.endsWith('_shown') || key.endsWith('_count'))) {
                        if (!key.includes('T') && !key.includes('Z') && !key.includes('-')) {
                            keysToRemove.push(key);
                            continue;
                        }
                    }
                    if (key.startsWith(this.storageKeyBase)) {
                        if ((key.endsWith('_shown') || key.endsWith('_count')) && !key.includes(this.updatedAt)) keysToRemove.push(key);
                    }
                }
                keysToRemove.forEach((key)=>storage.removeItem(key));
            });
        } catch (error) {
        // 
        }
    }
    // Initialize and display popup if conditions are met
    init() {
        try {
            // Validate targeting
            if (!this.validateTargeting()) return false;
            const { frequency: frequency } = this.timing;
            if (frequency === 'once' && sessionStorage.getItem(this.popupKey)) return false;
            if (frequency === 'oncePerDay') {
                const lastShown = localStorage.getItem(this.popupKey);
                if (lastShown) {
                    const today = new Date().toDateString();
                    if (lastShown === today) return false;
                }
            }
            if (this.stopConditions.enableStopConditions !== false) {
                if (this.stopConditions.enableDisplayLimit && this.stopConditions.afterDisplayCount > 0) {
                    const displayCount = parseInt(localStorage.getItem(this.displayCountKey) || '0', 10);
                    if (displayCount >= this.stopConditions.afterDisplayCount) return false;
                }
                if (this.stopConditions.afterClose && localStorage.getItem(this.popupKey)) return false;
            }
            // Ensure we have content
            if (!this.content) // Silently fail if no content
            return false;
            // Create popup elements
            this.createPopupElements();
            // Show popup based on trigger
            this.handleDisplayTrigger();
            return true;
        } catch (error) {
            // Silent fail on errors
            return false;
        }
    }
    // True if the given path is a landing page (prefix /lp/ or exact /lp)
    static isLandingPagePath(pathname) {
        const invalid = !pathname || typeof pathname !== 'string';
        if (invalid) return false;
        const path = pathname.replace(/\/+$/, '') || '/';
        return path === '/lp' || path.startsWith('/lp/');
    }
    // Resolve the "page" URL when widget can run in top window or inside an iframe (embedding page = referrer)
    getPagePathnameForTargeting() {
        const path = window.location.pathname;
        const inIframe = window.self !== window.top;
        try {
            if (inIframe && document.referrer) {
                const refUrl = new URL(document.referrer);
                const refPath = refUrl.pathname || '/';
                if (refUrl.hostname && refPath) return refPath;
            }
        } catch (e) {
        // Fall through to path param or window pathname
        }
        // When in iframe, parent passes embedding page path as path= in iframe URL (e.g. path=%2Flp%2Fbackpain%2F)
        if (inIframe && typeof window.location.search === 'string') {
            const pathMatch = window.location.search.match(/[?&]path=([^&]+)/);
            if (pathMatch) try {
                const paramPath = decodeURIComponent(pathMatch[1].replace(/\+/g, ' '));
                if (paramPath && paramPath.startsWith('/')) return paramPath;
            } catch (e2) {
            // Fall through
            }
        }
        return path;
    }
    // Validate device and page targeting
    validateTargeting() {
        // Never show popup on landing pages (URL path prefix /lp/)
        const pagePath = this.getPagePathnameForTargeting();
        const isLanding = $60c68fbfc7faa88c$var$PopupLibrary.isLandingPagePath(pagePath);
        if (isLanding) return false;
        // Device check
        if (!this.targeting.devices.includes(this.deviceType)) return false;
        // Page check (use same resolved path so iframe embedding page is used when applicable)
        const currentPath = pagePath;
        const currentUrl = pagePath;
        if (this.targeting.excludedUrls && this.targeting.excludedUrls.length > 0) {
            if (this.targeting.excludedUrls.some((excludedUrl)=>{
                if (excludedUrl === '/') {
                    const isExactRootPath = currentUrl === '/' || currentUrl === '';
                    return isExactRootPath;
                }
                const isExactMatch = currentUrl === excludedUrl || currentUrl === `${excludedUrl}/` || currentUrl.startsWith(`${excludedUrl}?`);
                return isExactMatch;
            })) return false;
        }
        if (this.targeting.excludedUrlContains && this.targeting.excludedUrlContains.length > 0) {
            if (this.targeting.excludedUrlContains.some((excludedPattern)=>{
                return currentUrl.includes(excludedPattern);
            })) return false;
        }
        const passed = this.targeting.pages.some((page)=>page === '*' || currentPath.includes(page));
        return passed;
    }
    handleEscapeKey(e) {
        if (e.key === 'Escape' && document.body.contains(this.popupWrapper)) this.closePopup();
    }
    createPopupElements() {
        // Create wrapper for Shadow DOM
        this.popupWrapper = document.createElement('div');
        this.popupWrapper.id = `popup-wrapper-${this.id}`;
        // Create shadow DOM
        this.shadowRoot = this.popupWrapper.attachShadow({
            mode: 'closed'
        });
        // Create container
        this.popupContainer = document.createElement('div');
        this.popupContainer.id = `popup-${this.id}`;
        this.popupContainer.innerHTML = this.content;
        this.popupContainer.style.display = 'none';
        const positionStyles = this.getPositionStyles();
        const styleElem = document.createElement('style');
        styleElem.textContent = `
      :host {
        all: initial;
      }
      #popup-${this.id} {
        position: fixed;
        z-index: 99999999999;
        ${positionStyles}
        background-color: #fff;
        box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        border-radius: 5px;
        max-width: 90%;
        width: ${this.contentWidth}px;
        max-height: 90%;
        overflow: auto;
        will-change: transform, opacity;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
        color: #333;
        line-height: 1.5;
        box-sizing: border-box;
        opacity: 1;
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        contain: layout style paint;
      }
      #popup-${this.id} * {
        box-sizing: border-box;
      }
      
      /* Animation Initial States */
      ${this.generateAnimationCSS()}
      
      /* Animation Final States */
      #popup-${this.id}.show {
        ${this.getAnimationTransform('', 1)};
      }
      .popup-overlay-${this.id} {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        z-index: 99999999998;
        opacity: 0;
        transition: opacity 0.3s ease;
        will-change: opacity;
      }
      .popup-overlay-${this.id}.show {
        opacity: 1;
      }
      .popup-close-btn {
        position: absolute;
        top: 5px;
        right: 5px;
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #fff;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        margin: 0;
      }
      .popup-close-btn:hover {
        color: #000;
        background-color: #f0f0f0;
        border-radius: 50%;
      }
      @media (max-width: 768px) {
        #popup-${this.id} {
          width: 90%;
          max-width: 90%;
        }
      }
    `;
        // Create overlay
        this.overlay = document.createElement('div');
        this.overlay.className = `popup-overlay-${this.id}`;
        this.overlay.addEventListener('click', (e)=>{
            if (e.target === this.overlay) this.closePopup();
        });
        // Create close button
        this.closeBtn = document.createElement('button');
        this.closeBtn.className = 'popup-close-btn';
        this.closeBtn.innerHTML = "\xd7";
        this.closeBtn.setAttribute('aria-label', 'Close');
        this.closeBtn.addEventListener('click', ()=>this.closePopup());
        // Append close button
        this.popupContainer.appendChild(this.closeBtn);
        // Append all elements to shadow root
        this.shadowRoot.appendChild(styleElem);
        this.shadowRoot.appendChild(this.overlay);
        this.shadowRoot.appendChild(this.popupContainer);
    }
    showPopup() {
        // Add event listeners
        document.addEventListener('keydown', this.escapeKeyHandler);
        // Add wrapper to DOM (contains shadow root) - but keep hidden initially
        document.body.appendChild(this.popupWrapper);
        // Prerender the popup content and wait for it to be ready
        this.preRenderAndShow();
        // Update display count - always use localStorage for metrics
        const currentCount = parseInt(localStorage.getItem(this.displayCountKey) || '0', 10);
        localStorage.setItem(this.displayCountKey, (currentCount + 1).toString());
        const { frequency: frequency } = this.timing;
        if (frequency === 'once') sessionStorage.setItem(this.popupKey, 'true');
        else if (frequency === 'oncePerDay') {
            const today = new Date().toDateString();
            localStorage.setItem(this.popupKey, today);
        }
    }
    preRenderAndShow() {
        this.setPopupVisibility(false);
        // Wait for all content to load, then show with animation
        this.waitForAllContentLoaded().then(()=>this.showWithSmoothAnimation()).catch(()=>this.showWithSmoothAnimation()); // Fallback if loading fails
    }
    setPopupVisibility(visible) {
        if (visible) {
            this.popupContainer.style.visibility = 'visible';
            this.popupContainer.style.opacity = '1';
        } else {
            this.popupContainer.style.display = 'block';
            this.popupContainer.style.visibility = 'hidden';
            this.popupContainer.style.opacity = '0';
        }
    }
    waitForAllContentLoaded() {
        return new Promise((resolve, reject)=>{
            const images = this.popupContainer.querySelectorAll('img');
            if (images.length === 0) {
                resolve();
                return;
            }
            let loadedCount = 0;
            const totalImages = images.length;
            const timeout = setTimeout(()=>reject(new Error('Timeout')), 3000);
            const handleImageComplete = ()=>{
                loadedCount++;
                if (loadedCount >= totalImages) {
                    clearTimeout(timeout);
                    resolve();
                }
            };
            images.forEach((img)=>{
                if (img.complete && img.naturalHeight !== 0) handleImageComplete();
                else {
                    img.addEventListener('load', handleImageComplete, {
                        once: true
                    });
                    img.addEventListener('error', handleImageComplete, {
                        once: true
                    });
                }
            });
        });
    }
    showWithSmoothAnimation() {
        this.setPopupVisibility(true);
        this.popupContainer.classList.add(`popup-${this.animation}-initial`);
        this.popupContainer.offsetHeight;
        setTimeout(()=>{
            this.overlay.classList.add('show');
            this.popupContainer.classList.remove(`popup-${this.animation}-initial`);
            this.popupContainer.classList.add('show');
        }, 10);
    }
    closePopup() {
        if (!this.popupContainer || !this.overlay) return;
        // Remove event listeners to prevent memory leaks
        document.removeEventListener('keydown', this.escapeKeyHandler);
        this.popupContainer.classList.remove('show');
        this.overlay.classList.remove('show');
        if (this.stopConditions.enableStopConditions !== false && this.stopConditions.afterClose) {
            const { frequency: frequency } = this.timing;
            if (frequency === 'once') sessionStorage.setItem(this.popupKey, 'true');
            else if (frequency === 'oncePerDay') {
                const today = new Date().toDateString();
                localStorage.setItem(this.popupKey, today);
            } else localStorage.setItem(this.popupKey, 'true');
        }
        setTimeout(()=>{
            this.removeElements();
        }, 300);
    }
    // Remove elements from DOM
    removeElements() {
        if (document.body.contains(this.popupWrapper)) document.body.removeChild(this.popupWrapper);
    }
    // Handle display triggers
    handleDisplayTrigger() {
        const delay = (this.timing.delay || 0) * 1000;
        if (this.displayTrigger === 'time') setTimeout(()=>this.showPopup(), delay);
        else if (this.displayTrigger === 'scroll') {
            let scrollTriggered = false;
            const scrollHandler = ()=>{
                if (!scrollTriggered && window.scrollY > 100) {
                    scrollTriggered = true;
                    window.removeEventListener('scroll', scrollHandler);
                    setTimeout(()=>this.showPopup(), delay);
                }
            };
            window.addEventListener('scroll', scrollHandler);
        } else if (this.displayTrigger === 'exit') {
            const exitHandler = (e)=>{
                if (e.clientY <= 0) {
                    document.removeEventListener('mouseleave', exitHandler);
                    setTimeout(()=>this.showPopup(), delay);
                }
            };
            document.addEventListener('mouseleave', exitHandler);
        }
    }
    getPositionStyles() {
        const positions = {
            'top-left': 'top: 20px; left: 20px;',
            'top-right': 'top: 20px; right: 20px;',
            'bottom-left': 'bottom: 20px; left: 20px;',
            'bottom-right': 'bottom: 20px; right: 20px;',
            'top-center': 'top: 20px; left: 50%; transform: translateX(-50%);',
            'top': 'top: 20px; left: 50%; transform: translateX(-50%);',
            'bottom-center': 'bottom: 20px; left: 50%; transform: translateX(-50%);',
            'bottom': 'bottom: 20px; left: 50%; transform: translateX(-50%);',
            'left': 'top: 50%; left: 20px; transform: translateY(-50%);',
            'right': 'top: 50%; right: 20px; transform: translateY(-50%);',
            'center': 'top: 50%; left: 50%; transform: translate(-50%, -50%);'
        };
        return positions[this.position] || positions.center;
    }
    generateAnimationCSS() {
        const ANIMATION_CONFIG = {
            fade: {
                transform: '',
                opacity: 0
            },
            slide: {
                transform: 'translateX(100px)',
                opacity: 0
            },
            zoom: {
                transform: 'scale(0.7)',
                opacity: 0
            },
            scale: {
                transform: 'scale(0.7)',
                opacity: 0
            },
            bounce: {
                transform: 'scale(0.3)',
                opacity: 0
            },
            'slide-up': {
                transform: 'translateY(100px)',
                opacity: 0
            },
            'slide-down': {
                transform: 'translateY(-100px)',
                opacity: 0
            },
            none: {
                transform: '',
                opacity: 1
            }
        };
        return Object.entries(ANIMATION_CONFIG).map(([name, config])=>`
                #popup-${this.id}.popup-${name}-initial {
                    ${this.getAnimationTransform(config.transform, config.opacity)};
                    transition: none !important;
                }`).join('');
    }
    getAnimationTransform(animationTransform = '', opacity = 1) {
        const baseTransforms = {
            'top-left': animationTransform || 'none',
            'top-right': animationTransform || 'none',
            'bottom-left': animationTransform || 'none',
            'bottom-right': animationTransform || 'none',
            'top-center': animationTransform ? `translateX(-50%) ${animationTransform}` : 'translateX(-50%)',
            'top': animationTransform ? `translateX(-50%) ${animationTransform}` : 'translateX(-50%)',
            'bottom-center': animationTransform ? `translateX(-50%) ${animationTransform}` : 'translateX(-50%)',
            'bottom': animationTransform ? `translateX(-50%) ${animationTransform}` : 'translateX(-50%)',
            'left': animationTransform ? `translateY(-50%) ${animationTransform}` : 'translateY(-50%)',
            'right': animationTransform ? `translateY(-50%) ${animationTransform}` : 'translateY(-50%)',
            'center': animationTransform ? `translate(-50%, -50%) ${animationTransform}` : 'translate(-50%, -50%)'
        };
        const transform = baseTransforms[this.position] || baseTransforms.center;
        return `transform: ${transform}; opacity: ${opacity};`;
    }
}
var $60c68fbfc7faa88c$export$2e2bcd8739ae039 = $60c68fbfc7faa88c$var$PopupLibrary;


/**
 * Check if a pathname matches any of the given URL patterns.
 *
 * Supported patterns:
 *   /lp/botox       — exact match
 *   /lp/*           — prefix wildcard (matches /lp/anything)
 *   *botox*         — contains wildcard
 *
 * Matching is case-insensitive and trailing slashes are normalized.
 */ function $1a1097a05fd37881$export$208dca91e1be4d97(pathname, patterns) {
    if (!patterns || !patterns.length) return false;
    const normalizedPath = $1a1097a05fd37881$var$normalizePath(pathname);
    return patterns.some((pattern)=>{
        const p = $1a1097a05fd37881$var$normalizePath(pattern);
        // Contains wildcard: *something*
        if (p.startsWith('*') && p.endsWith('*') && p.length > 2) {
            const inner = p.slice(1, -1);
            return normalizedPath.includes(inner);
        }
        // Prefix wildcard: /lp/*
        if (p.endsWith('/*')) {
            const prefix = p.slice(0, -2);
            return normalizedPath === prefix || normalizedPath.startsWith(prefix + '/');
        }
        // Exact match
        return normalizedPath === p;
    });
}
function $1a1097a05fd37881$var$normalizePath(path) {
    if (!path) return '';
    // Remove trailing slash (unless it's just "/"), lowercase
    let normalized = path.toLowerCase().trim();
    if (normalized.length > 1 && normalized.endsWith('/')) normalized = normalized.slice(0, -1);
    return normalized;
}


const $a2b6b7e174bc02eb$var$scripts = document.querySelectorAll('script[data-id="assistant"]');
const $a2b6b7e174bc02eb$var$selector = $a2b6b7e174bc02eb$var$scripts[$a2b6b7e174bc02eb$var$scripts.length - 1];
const $a2b6b7e174bc02eb$var$url = $a2b6b7e174bc02eb$var$selector.getAttribute('src').includes('widget.js') ? $a2b6b7e174bc02eb$var$selector.getAttribute('src').substring(0, $a2b6b7e174bc02eb$var$selector.getAttribute('src').length - 10) : window.location.origin;
const $a2b6b7e174bc02eb$var$formId = (0, $er9E0.params)('form_id') ? (0, $er9E0.params)('form_id') : $a2b6b7e174bc02eb$var$selector.getAttribute('form');
const $a2b6b7e174bc02eb$var$widgetModal = $a2b6b7e174bc02eb$var$selector.getAttribute('data-popup');
const $a2b6b7e174bc02eb$var$appointmentChannel = (0, $er9E0.params)('appointment_channel_id') ? (0, $er9E0.params)('appointment_channel_id') : $a2b6b7e174bc02eb$var$selector.getAttribute('appointment_channel');
(0, $cEKee.setAppUrl)($a2b6b7e174bc02eb$var$url);
(0, $cEKee.setFormId)($a2b6b7e174bc02eb$var$formId);
$a2b6b7e174bc02eb$var$getData();
(0, $cEKee.setIsModalPopup)(!!$a2b6b7e174bc02eb$var$widgetModal);
(0, $cEKee.setAppointmentChannelId)($a2b6b7e174bc02eb$var$appointmentChannel);
async function $a2b6b7e174bc02eb$var$getData() {
    const form = await (0, $1f5FT.getFormByFormId)($a2b6b7e174bc02eb$var$formId, (0, $cEKee.appointmentChannelId) || $a2b6b7e174bc02eb$var$appointmentChannel);
    const currentPath = window.location.pathname;
    // Check if a sibling widget should load on this page instead
    const siblingOverrides = form.data.sibling_overrides || [];
    for (const sibling of siblingOverrides){
        if ((0, $1a1097a05fd37881$export$208dca91e1be4d97)(currentPath, sibling.show_only_on_urls)) try {
            const siblingForm = await (0, $1f5FT.getFormByFormId)(sibling.uuid, (0, $cEKee.appointmentChannelId) || $a2b6b7e174bc02eb$var$appointmentChannel);
            (0, $cEKee.setFormId)(sibling.uuid);
            (0, $cEKee.setTooltip)(siblingForm.data.title_tooltip);
            (0, $cEKee.setPicture)(siblingForm.data.picture);
            (0, $cEKee.setIsHiddenOnDesktop)(siblingForm?.data?.hide_on_desktop ?? false);
            (0, $cEKee.setIsHiddenOnMobile)(siblingForm?.data?.hide_on_mobile ?? false);
            (0, $cEKee.setIsHiddenPoweredBy)(siblingForm?.data?.hide_powered_by ?? false);
            (0, $cEKee.setIsWhitelabel)(siblingForm?.data?.project?.whitelabel ?? false);
            if (siblingForm.data.popup_campaign) try {
                const popup = new (0, $60c68fbfc7faa88c$export$2e2bcd8739ae039)(siblingForm.data.popup_campaign);
                popup.init();
            } catch (e) {}
            await $a2b6b7e174bc02eb$export$43fe127fc3f91e2(siblingForm.data);
            return;
        } catch (e) {
        // If sibling fetch fails, fall through to default widget
        }
    }
    // URL filters only apply when the widget is embedded on a third-party site.
    // Skip when loaded directly (assistant page) or inside an iframe (embedding).
    const isDirectLoad = window.location.hostname === 'assistant.pilotpractice.com' || window.location.hostname === 'assistant.kloudmd.com';
    const isEmbedded = (0, $hvLQT.apiClient).inIframe();
    if (!isDirectLoad && !isEmbedded) {
        // If default widget has show_only_on_urls, only render on matching pages
        const showOnlyUrls = form.data.show_only_on_urls;
        const widgetHiddenByShowOnly = Array.isArray(showOnlyUrls) && showOnlyUrls.length > 0 && !(0, $1a1097a05fd37881$export$208dca91e1be4d97)(currentPath, showOnlyUrls);
        // Check if default widget should be hidden on this page
        const hideOnUrls = form.data.hide_widget_on_urls;
        const widgetHiddenByHideOn = Array.isArray(hideOnUrls) && hideOnUrls.length > 0 && (0, $1a1097a05fd37881$export$208dca91e1be4d97)(currentPath, hideOnUrls);
        if (widgetHiddenByShowOnly || widgetHiddenByHideOn) {
            // Widget is hidden on this page, but popup campaigns run independently
            if (form.data.popup_campaign) try {
                const popup = new (0, $60c68fbfc7faa88c$export$2e2bcd8739ae039)(form.data.popup_campaign);
                popup.init();
            } catch (e) {
            // Silently handle popup initialization errors
            }
            return;
        }
    }
    // Normal flow — render default widget
    (0, $cEKee.setTooltip)(form.data.title_tooltip);
    (0, $cEKee.setPicture)(form.data.picture);
    (0, $cEKee.setIsHiddenOnDesktop)(form?.data?.hide_on_desktop ?? false);
    (0, $cEKee.setIsHiddenOnMobile)(form?.data?.hide_on_mobile ?? false);
    (0, $cEKee.setIsHiddenPoweredBy)(form?.data?.hide_powered_by ?? false);
    (0, $cEKee.setIsWhitelabel)(form?.data?.project?.whitelabel ?? false);
    if (form.data.popup_campaign) try {
        const popup = new (0, $60c68fbfc7faa88c$export$2e2bcd8739ae039)(form.data.popup_campaign);
        popup.init();
    } catch (e) {
    // Silently handle popup initialization errors
    }
    await $a2b6b7e174bc02eb$export$43fe127fc3f91e2(form.data);
}
function $a2b6b7e174bc02eb$var$listenMessageIframe(event) {
    if (event.data === (0, $cIxq8.UPDATE_APPOINTMENT_CHANNEL)) {
        const assistantIframeTemp = document.querySelector('.assistant__container .assistant__content--iframe');
        if (assistantIframeTemp) assistantIframeTemp.contentWindow.postMessage((0, $cIxq8.UPDATE_APPOINTMENT_CHANNEL), '*');
        else {
            parent.postMessage((0, $cIxq8.UPDATE_APPOINTMENT_CHANNEL), "*");
            document.querySelector('iframe').contentWindow.postMessage((0, $cIxq8.UPDATE_APPOINTMENT_CHANNEL), "*");
        }
    }
}
async function $a2b6b7e174bc02eb$export$43fe127fc3f91e2(response) {
    (0, $cEKee.setPrimaryColor)(response.color_theme);
    (0, $cEKee.setPhoneToCall)(response.project?.business_phone);
    (0, $cEKee.setAccessToken)(response.token);
    await $a2b6b7e174bc02eb$var$createLeadFromImageUploadLink();
    window.addEventListener('message', $a2b6b7e174bc02eb$var$listenMessageIframe);
    // const parser = new UAParser(window.navigator.userAgent);
    // currently, we don't redirect if in iframe
    // if (parser.getDevice().type === "mobile" && apiClient.inIframe()) {
    //     document.querySelector('body').insertAdjacentHTML('beforeend', "<div style='top:0;left:0;width:100%;height:100%;position:absolute;' id='redirectOverlay'></div>");
    //     document.getElementById('redirectOverlay').addEventListener('click', () => {
    //         top.location.href = window.location.origin + `?form_id=${params('form_id')}&is_open_assistant=true`;
    //     }, { once: true });
    // }
    if ((0, $hvLQT.apiClient).inIframe() && !(0, $er9E0.params)((0, $cIxq8.IGNORE_IFRAME)) || ((0, $er9E0.params)((0, $cIxq8.FULL_PAGE)) || (0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID))) && !(0, $er9E0.params)((0, $cIxq8.IGNORE_IFRAME))) {
        let landingPageParam = '';
        let fullWidth = !!(0, $er9E0.params)((0, $cIxq8.FULL_PAGE)) || !!(0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID));
        let htmlContent = '';
        const staffIdParam = (0, $er9E0.params)('staff_id') ? `&staff_id=${(0, $er9E0.params)('staff_id')}` : '';
        const procedureIdParam = (0, $er9E0.params)('procedure_id') ? `&procedure_id=${(0, $er9E0.params)('procedure_id')}` : '';
        if ((0, $er9E0.params)((0, $cIxq8.UPLOAD_ID_PARAM))) landingPageParam = `&${0, $cIxq8.UPLOAD_ID_PARAM}=${(0, $er9E0.params)((0, $cIxq8.UPLOAD_ID_PARAM))}`;
        else if ((0, $er9E0.params)((0, $cIxq8.EVENT_ID_PARAM))) {
            landingPageParam = `&${0, $cIxq8.EVENT_ID_PARAM}=${(0, $er9E0.params)((0, $cIxq8.EVENT_ID_PARAM))}`;
            if ((0, $er9E0.params)('signature') && (0, $er9E0.params)('expires')) {
                landingPageParam += `&signature=${encodeURIComponent((0, $er9E0.params)('signature'))}&expires=${(0, $er9E0.params)('expires')}`;
                if ((0, $er9E0.params)('v')) landingPageParam += `&v=${(0, $er9E0.params)('v')}`;
            }
        } else if ((0, $er9E0.params)((0, $cIxq8.ESTIMATE_ID_PARAM))) landingPageParam = `&${0, $cIxq8.ESTIMATE_ID_PARAM}=${(0, $er9E0.params)((0, $cIxq8.ESTIMATE_ID_PARAM))}`;
        if ((0, $er9E0.params)((0, $cIxq8.ESTIMATE))) landingPageParam += `&${0, $cIxq8.ESTIMATE}=true`;
        if (staffIdParam) landingPageParam += staffIdParam;
        if (procedureIdParam) landingPageParam += procedureIdParam;
        if ((0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID)) && response?.appointment_channel?.appointment_channel_name) document.title = response.appointment_channel.appointment_channel_name;
        if ((0, $er9E0.params)((0, $cIxq8.FULL_PAGE)) && (0, $er9E0.params)((0, $cIxq8.BOOK_APPOINTMENT_PARAM)) && (0, $cIxq8.DESKTOP_SCREEN) || (0, $er9E0.params)((0, $cIxq8.FULL_PAGE)) && (0, $er9E0.params)('staff_id') && (0, $er9E0.params)('procedure_id') && (0, $cIxq8.DESKTOP_SCREEN)) {
            (0, $9b211f1727672a7a$export$40005d3795cfa755)();
            (0, $9b211f1727672a7a$export$bd41ba04006fde31)();
            (0, $cEKee.setForm)(response);
            htmlContent = (0, $9b211f1727672a7a$export$2edf8f7d74ebd6c8)(response.project);
            if (document?.querySelector(".wrapper-login")) document?.querySelector(".wrapper-login").remove();
            document.body.insertAdjacentHTML('beforeend', `${htmlContent}`);
            (0, $bc16125a2dafc66b$export$f74bf3aa4976c520)();
            if ((0, $cEKee.leadInfo)?.id) $a2b6b7e174bc02eb$var$renderIframeWidget(landingPageParam, fullWidth, true);
        } else $a2b6b7e174bc02eb$var$renderIframeWidget(landingPageParam, fullWidth, false);
    } else (0, $f700423338ff395d$export$18d0fd55b1b3892d)();
}
async function $a2b6b7e174bc02eb$var$createLeadFromImageUploadLink() {
    if ((0, $er9E0.params)((0, $cIxq8.NEW_LEAD_UPLOAD))) {
        let newLead = await (0, $2q2gk.createLead)({
            'first_name': (0, $er9E0.params)('first_name'),
            'last_name': (0, $er9E0.params)('last_name'),
            'email': (0, $er9E0.params)('email'),
            'phone': (0, $er9E0.params)('phone')
        });
        (0, $cEKee.setLeadInfo)(newLead.data);
        (0, $cEKee.setLeadTextId)(newLead.data.text_id);
    }
}
function $a2b6b7e174bc02eb$var$addCSSStyles(css, id = null) {
    if (id && document.getElementById(id)) return;
    const styleTag = document.createElement('style');
    if (id) styleTag.id = id;
    styleTag.innerHTML = css;
    document.head.append(styleTag);
}
function $a2b6b7e174bc02eb$var$addIframeResponsiveStyles(isBookingFlow, fullWidth) {
    if (!isBookingFlow) $a2b6b7e174bc02eb$var$addCSSStyles(`
            .iframe-widget--standard {
                @media only screen and (max-width: 540px) {
                    width: 100% !important;
                }
            }
        `, 'iframe-standard-responsive');
    if (isBookingFlow) $a2b6b7e174bc02eb$var$addCSSStyles(`
            .iframe-widget--booking {
                @media only screen and (max-width: 600px) {
                    width: 100% !important;
                    height: 100% !important;
                }
            }
        `, 'iframe-booking-responsive');
    if (fullWidth) $a2b6b7e174bc02eb$var$addCSSStyles(`
            .block__iframe iframe {
                @media only screen and (max-width: 600px) {
                    width: 100%;
                    height: 100%;
                }
            }
        `, 'iframe-fullwidth-legacy');
}
function $a2b6b7e174bc02eb$var$renderIframeWidget(landingPageParam, fullWidth, isAppointmentWebpage) {
    const isBookAppointmentFlow = (0, $er9E0.params)('staff_id') && (0, $er9E0.params)('procedure_id') || (0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID));
    const isBookingFlow = (isBookAppointmentFlow && (0, $er9E0.params)((0, $cIxq8.FULL_PAGE)) || (0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID))) && !(0, $cIxq8.MOBILE_SCREEN);
    let companyName = (0, $er9E0.params)('appUrl')?.includes('kloudmd') ? 'KloudMD' : 'PilotPractice';
    let poweredByHtml = (0, $cEKee.isHiddenPoweredBy) || (0, $cEKee.isWhitelabel) || (0, $hvLQT.apiClient).inIframe() ? '' : `
        <span class="footer" style="font-size: 14px; color: gray; font-family: Poppins, sans-serif; cursor: pointer;">
            <span>Powered by <b style="margin-left: 3px;"><u class="powered_by">${companyName}</u></b></span>
        </span>
    `;
    let htmlContent = `
    <div style="background-color: #f1f4f6; width: ${isAppointmentWebpage ? '100%' : '100vw'}; height: ${isAppointmentWebpage ? '100%' : '100vh'}; display: flex; flex-direction: column; align-items: center; gap: 30px; ${isBookingFlow ? '' : 'align-items: center'};" class="block__iframe">
        <iframe src="${(0, $cEKee.appUrl)}?form_id=${$a2b6b7e174bc02eb$var$formId}&ignore_iframe=1${landingPageParam}${fullWidth ? '&full_page=1' : ''}${(0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID)) ? `&appointment_channel_id=${(0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID))}` : ''}" style="border: none; border-radius: 16px; box-shadow: rgb(204 204 204) 0px 0px 8px; ${isBookingFlow ? 'margin-top: 66px;' : 'width: 540px;'} " class="iframe-widget ${isBookingFlow ? 'iframe-widget--booking' : 'iframe-widget--standard'}" ${isBookingFlow ? `width="800" height="612"` : `height="612"`}></iframe>
        ${poweredByHtml}
    </div >
`;
    $a2b6b7e174bc02eb$var$addIframeResponsiveStyles(isBookingFlow, fullWidth);
    if (isAppointmentWebpage) {
        document.querySelector(".wrapper-login .container-right").innerHTML = "";
        document.querySelector(".wrapper-login .container-right").insertAdjacentHTML('beforeend', `${htmlContent}`);
    } else {
        document.querySelector('body').style.margin = 0;
        document.body.insertAdjacentHTML('beforeend', `${htmlContent}`);
    }
    if (!(0, $cEKee.isWhitelabel)) {
        let url = (0, $er9E0.params)('appUrl');
        let companyUrl = url?.includes('kloudmd') ? 'https://kloudmd.com' : 'https://pilotpractice.com';
        document.querySelectorAll('.footer span').forEach((i)=>{
            i.onclick = ()=>{
                window.parent.parent.location.href = `${companyUrl}${(0, $cEKee.sourceParam) ? `?source=${0, $cEKee.sourceParam}` : ''}`;
            };
        });
    }
}


//# sourceMappingURL=repo.f15970b2.js.map
